const COMMON_DOMAINS = [
  "gmail.com",
  "hotmail.com",
  "outlook.com",
  "yahoo.com",
  "icloud.com",
  "live.com",
  "bol.com.br",
  "uol.com.br",
  "terra.com.br",
  "oi.com.br",
  "ig.com.br",
];

const COMMON_TLDS = ["com", "com.br", "net", "org", "edu", "gov.br"];

function levenshtein(a: string, b: string) {
  if (a === b) return 0;
  const m = Array.from({ length: a.length + 1 }, (_, i) => [
    i,
    ...Array(b.length).fill(0),
  ]);
  for (let j = 0; j <= b.length; j++) m[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      m[i][j] = Math.min(
        m[i - 1][j] + 1,
        m[i][j - 1] + 1,
        m[i - 1][j - 1] + cost
      );
    }
  }
  return m[a.length][b.length];
}

export function normalizeEmail(input: string) {
  const email = input.trim().replace(/\s+/g, "");
  const at = email.indexOf("@");
  if (at < 0) return { email, local: email, domain: "", tld: "" };
  const local = email.slice(0, at);
  const domain = email.slice(at + 1).toLowerCase();
  const parts = domain.split(".");
  const tld = parts.length > 1 ? parts.slice(1).join(".") : "";
  return { email: `${local}@${domain}`, local, domain, tld };
}

export function suggestEmailCorrection(input: string) {
  const { local, domain, tld } = normalizeEmail(input);
  if (!domain) return null;

  // 1) TLDs muito comuns digitados errado
  const tldSuggestion = (() => {
    const t = tld || ""; // ex: "cm", "cpm", "con"
    if (!t) return null;
    let best = null as null | string;
    let bestDist = Infinity;
    for (const candidate of COMMON_TLDS) {
      const d = levenshtein(t, candidate);
      if (d < bestDist) {
        bestDist = d;
        best = candidate;
      }
    }
    return bestDist <= 1 ? best : null;
  })();

  // 2) Domínios inteiros (gmail.com vs gmai.com / gmail.cm)
  let bestDomain = null as null | string;
  let bestDist = Infinity;
  for (const cand of COMMON_DOMAINS) {
    const d = levenshtein(domain, cand);
    if (d < bestDist) {
      bestDist = d;
      bestDomain = cand;
    }
  }

  // heurística: distância pequena (1–2)
  const domainSuggestion = bestDist <= 2 ? bestDomain : null;

  // Mesclar heurísticas: se as duas existem, prioriza domínio inteiro
  let suggestedDomain = domainSuggestion;
  if (!suggestedDomain && tldSuggestion) {
    // Corrige só o TLD mantendo o label antes
    const labels = domain.split(".");
    if (labels.length) {
      const first = labels[0]; // ex: "gmail" em "gmail.cm"
      suggestedDomain = `${first}.${tldSuggestion}`;
    }
  }

  if (suggestedDomain && suggestedDomain !== domain) {
    return `${local}@${suggestedDomain}`;
  }
  return null;
}
